import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "@xyflow/react";
import { X, ArrowLeftRight, ArrowRight } from "lucide-react";

export default function FlowEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, markerEnd, markerStart, data, selected }) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  const editable = !!data?.onDelete;
  const bidirectional = !!data?.bidirectional;

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} markerStart={markerStart}
        style={{ stroke: "#E63946", strokeWidth: selected ? 3 : 2 }} />
      {editable && selected && (
        <EdgeLabelRenderer>
          <div
            style={{ position: "absolute", transform: `translate(-50%,-50%) translate(${labelX}px,${labelY}px)`, pointerEvents: "all" }}
            className="nodrag nopan flex items-center gap-1 rounded-full bg-zinc-900 border border-zinc-700 p-0.5 shadow-lg">
            <button data-testid={`edge-toggle-${id}`} title={bidirectional ? "Make one-way" : "Make two-way"}
              onClick={(e) => { e.stopPropagation(); data.onToggle(id); }}
              className="h-6 w-6 rounded-full flex items-center justify-center text-zinc-300 hover:text-white hover:bg-white/10 transition-colors">
              {bidirectional ? <ArrowLeftRight className="h-3.5 w-3.5" /> : <ArrowRight className="h-3.5 w-3.5" />}
            </button>
            <button data-testid={`edge-delete-${id}`} title="Delete line"
              onClick={(e) => { e.stopPropagation(); data.onDelete(id); }}
              className="h-6 w-6 rounded-full flex items-center justify-center text-zinc-300 hover:text-white hover:bg-destructive transition-colors">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
